module.exports = __webpack_public_path__ + "img/instagram.1cf14f5e.svg";